import React from 'react';
import './forms/DoveForm.css';

const ProductInfoModal = ({ selectedProduct, onContinue, onClose }) => {
  if (!selectedProduct) return null;

  return (
    <div className="product-info-modal">
      <div className="product-info-container">
        <div className="dove-form-header">
          <div className="nuevo-tag-container">
            <div className="nuevo-tag"><span>NUEVO</span></div>
          </div>
          <div className="dove-logo-container">
            <img
              src="/dove_logo_deo.svg"
              alt="Dove all body deo"
              className="dove-logo-svg"
              onError={(e) => {
                e.target.style.display = 'none';
                console.error('Failed to load dove logo SVG');
              }}
            />
          </div>
        </div>
        <div className="product-content">
          <div className="product-image-section">
            <img 
              src="/product_info_1.jpg" 
              alt="Dove All Body Deo Products"
              className="product-image-1"
            />
          </div>
          
          <div className="product-text-section">
            <h2 className="product-title">CONTROL DEL OLOR PARA TODAS TUS CURVAS</h2>
          </div>
          
          <div className="product-image-section">
            <img 
              src="/product_info_2.jpg" 
              alt="Dove All Body Deo Usage"
              className="product-image-2"
            />
          </div>
          
          <div className="product-cta-section">
            <p className="product-description">
              RESPONDÉ EL CUESTIONARIO<br/>
              Y AYUDANOS A SEGUIR MEJORANDO<br/>
              NUESTROS PRODUCTOS
            </p>
            
            <button 
              onClick={onContinue}
              className="dove-form-submit enabled"
            >
              CONTINUAR
            </button>
          </div>
        </div>

        {/* Close button */}
        {onClose && (
          <button
            onClick={onClose}
            className="dove-form-close"
            type="button"
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
};

export default ProductInfoModal;
